const createBoundsFromPoints = (coordinates) => {
  const bounds = new window.google.maps.LatLngBounds()

  coordinates.map((coordinate) => bounds.extend(coordinate))
  return bounds
}

export default createBoundsFromPoints
